import { PlageFonctionnementDocument } from './PlageFonctionnementDocument';
import { MobiDocument } from './MobiDocument';
import { ElementFriseActiviteDocument } from './ElementFriseActiviteDocument';
import { TarifActiviteDocument } from './TarifActiviteDocument';

export class TarifEventSchedulerActiviteDocument extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private activite_id: number;
    private resource_id: string;
    private start_date: string;
    private end_date: string;
    private date: string;
    private plageFonctionnement_id: number;
    private service_id: number;
    private name: string;
    private tarif_id: number;


    //Attributs for Vuejs
    private plageIntitule: string;
    private friseElement_id: number;
    private tempsTarif_id: number;
    private heure_debut_fixe: string | null;
    private heure_fin_fixe: string | null;

    public constructor(tarifeventscheduler: any) {
        super();
        this._id = tarifeventscheduler._id;
        this._rev = tarifeventscheduler._rev;
        this.id = tarifeventscheduler.id;
        this.activite_id = tarifeventscheduler.activite_id;
        this.resource_id = tarifeventscheduler.resource_id;
        this.start_date = tarifeventscheduler.start_date;
        this.end_date = tarifeventscheduler.end_date;
        this.plageFonctionnement_id = tarifeventscheduler.plageFonctionnement_id;
        this.service_id = tarifeventscheduler.service_id;
        this.date = tarifeventscheduler.date;
        this.plageIntitule = ""
        this.friseElement_id = -1;
        this.tempsTarif_id = -1;
        this.tarif_id = tarifeventscheduler.tarif_id;
        this.name = tarifeventscheduler.name;
        if (tarifeventscheduler.heure_debut_fixe)
            this.heure_debut_fixe = tarifeventscheduler.heure_debut_fixe;
        else
            this.heure_debut_fixe = null
        if (tarifeventscheduler.heure_fin_fixe)
            this.heure_fin_fixe = tarifeventscheduler.heure_fin_fixe;
        else
            this.heure_fin_fixe = null
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getActivite_id(): number {
        return this.activite_id;
    }

    public setActivite_id(activite_id: number): void {
        this.activite_id = activite_id;
    }


    public getResource_id(): string {
        return this.resource_id;
    }

    public setResource_id(resource_id: string): void {
        this.resource_id = resource_id;
    }

    public getStart_date(): string {
        return this.start_date;
    }

    public setStart_date(start_date: string): void {
        this.start_date = start_date;
    }

    public getEnd_date(): string {
        return this.end_date;
    }

    public setEnd_date(end_date: string): void {
        this.end_date = end_date;
    }

    public getPlageFonctionnement_id(): number {
        return this.plageFonctionnement_id;
    }

    public setPlageFonctionnement_id(plageFonctionnement_id: number): void {
        this.plageFonctionnement_id = plageFonctionnement_id;
    }


    public getPlageIntitule(): string {
        return this.plageIntitule;
    }

    public setPlageIntitule(plageIntitule: string): void {
        this.plageIntitule = plageIntitule;
    }

    public getFriseElement_id(): number {
        return this.friseElement_id;
    }

    public setFriseElement_id(friseElement_id: number): void {
        this.friseElement_id = friseElement_id;
    }

    public getTempsTarif_id(): number {
        return this.tempsTarif_id;
    }

    public setTempsTarif_id(tempsTarif_id: number): void {
        this.tempsTarif_id = tempsTarif_id;
    }

    public getService_id(): number {
        return this.service_id;
    }

    public setService_id(service_id: number): void {
        this.service_id = service_id;
    }

    public getHeure_debut_fixe(): string | null {
        return this.heure_debut_fixe;
    }

    public setHeure_debut_fixe(heure_debut_fixe: string | null): void {
        this.heure_debut_fixe = heure_debut_fixe;
    }

    public getHeure_fin_fixe(): string | null {
        return this.heure_fin_fixe;
    }

    public setHeure_fin_fixe(heure_fin_fixe: string | null): void {
        this.heure_fin_fixe = heure_fin_fixe;

    }

    public getDate(): string {
        return this.date;
    }

    public setDate(date: string): void {
        this.date = date;
    }


    public getName(): string {
        return this.name;
    }

    public setName(name: string): void {
        this.name = name;
    }

    public getTarif_id(): number {
        return this.tarif_id;
    }

    public setTarif_id(tarif_id: number): void {
        this.tarif_id = tarif_id;
    }


    public getPlageFonctionnement(): PlageFonctionnementDocument {
        return this.memdb.findOne({
            doctype: "PlageFonctionnementDocument",
            fkey: "id",
            fvalue: this.plageFonctionnement_id
        })
    }

    public getElementFriseActivite(activite_id: number): ElementFriseActiviteDocument | undefined {
        let listElementFrise: Array<ElementFriseActiviteDocument> = this.memdb.find({
            doctype: "ElementFriseActiviteDocument",
            fkey: "plageFonctionnement_id",
            fvalue: this.plageFonctionnement_id
        });
        let elem = listElementFrise.find((elementFrise: ElementFriseActiviteDocument) => elementFrise.getActivite_id() === activite_id);
        return elem
    }
    public getElementFriseActiviteWithDate(activite_id: number): ElementFriseActiviteDocument | undefined {
        let listElementFrise: Array<ElementFriseActiviteDocument> = this.memdb.find({
            doctype: "ElementFriseActiviteDocument",
            fkey: "activite_id",
            fvalue: activite_id
        });
        let elem = listElementFrise.find((elementFrise: ElementFriseActiviteDocument) =>
            elementFrise.getHeure_debut() === this.start_date.split(' ')[1] &&
            elementFrise.getHeure_fin() === this.end_date.split(' ')[1]);
        return elem
    }
    public getService(activite_id: number): ElementFriseActiviteDocument | undefined {
        let listElementFrise: Array<ElementFriseActiviteDocument> = this.memdb.find({
            doctype: "ElementFriseActiviteDocument",
            fkey: "service_id",
            fvalue: this.service_id
        });
        let elem = listElementFrise.find((elementFrise: ElementFriseActiviteDocument) => elementFrise.getActivite_id() === activite_id);
        return elem
    }

    public getTempsSup(activite_id: number): TarifActiviteDocument | undefined {
        let listTarifActivite: Array<TarifActiviteDocument> = this.memdb.findAll({
            doctype: "TarifActiviteDocument"
        });
        let tarif = listTarifActivite.find((tarifActivite: TarifActiviteDocument) =>
            tarifActivite.getActivite_id() === activite_id &&
            tarifActivite.getType() === this.resource_id &&
            tarifActivite.getHeure_debut() === this.start_date.split(' ')[1] &&
            tarifActivite.getHeure_fin() === this.end_date.split(' ')[1] &&
            tarifActivite.getId() === this.tarif_id
        )
        return tarif;
    }

    public getTarifActivite(): TarifActiviteDocument {
        return this.memdb.findOne({
            doctype: "TarifActiviteDocument",
            fkey: "id",
            fvalue: this.tarif_id
        });
    }
}